import React from 'react';

const CRMDashboardMetrics = ({ leads }) => {
    const totalLeads = leads.length;
    const leadsWon = leads.filter(l => l.status === 'won').length;
    const conversionRate = totalLeads > 0 ? ((leadsWon / totalLeads) * 100).toFixed(1) : 0;

    const leadsBySeller = leads.reduce((acc, lead) => {
        const sellerName = lead.sellerName || 'Desconocido';
        acc[sellerName] = (acc[sellerName] || 0) + 1;
        return acc;
    }, {});

    return (
        <div className="bg-white p-4 rounded-lg shadow-md mb-6">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Dashboard de Rendimiento</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
                <div className="bg-blue-50 p-4 rounded-lg">
                    <p className="text-3xl font-bold text-blue-600">{totalLeads}</p>
                    <p className="text-sm text-gray-600">Total de Leads</p>
                </div>
                <div className="bg-green-50 p-4 rounded-lg">
                    <p className="text-3xl font-bold text-green-600">{conversionRate}%</p>
                    <p className="text-sm text-gray-600">Tasa de Conversión</p>
                </div>
                <div className="bg-purple-50 p-4 rounded-lg">
                    <p className="text-xl font-bold text-purple-600">Leads por Vendedor</p>
                    <div className="text-xs text-gray-600 mt-2">
                        {Object.entries(leadsBySeller).map(([name, count]) => (
                            <div key={name} className="flex justify-between px-2">
                                <span>{name}</span>
                                <span>{count}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CRMDashboardMetrics;

